import API from "@/interceptors/Api";

export const removeRole = async (userId: string): Promise<void> => {
  await API.delete(`/cash-pooling/roles?userId=${encodeURIComponent(userId)}`);
};
